import { render, staticRenderFns } from "./CrewVeritasStory.vue?vue&type=template&id=261ba42a&scoped=true"
import script from "./CrewVeritasStory.vue?vue&type=script&lang=js"
export * from "./CrewVeritasStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ba42a",
  null
  
)

export default component.exports